import { useEffect, useState } from "react";
import styled from "styled-components";

const StyledSliderContainer = styled.section`
  width: 100%;
  height: auto;
  max-height: 200px;
  display: flex;
  overflow: hidden;
  img {
    flex: 1;
    width: 100%;
  }
`;

const Slider = ({ images }) => {
  const totalSlides = images.length;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((index) => (index + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  return (
    <StyledSliderContainer>
      <img src={images[index]?.image} alt={`Slider`} />
    </StyledSliderContainer>
  );
};

export default Slider;
